export const mutations = {
  TOGGLE_PROFILE_CARD(state) {
    state.toggleProfile = !state.toggleProfile;
  },
  TURN_OFF_PROFILE_CARD(state) {
    state.toggleProfile = false;
  }
};
